module.exports = __webpack_public_path__ + "src-notif-thebookingbutton.png?0e1244f7e1c98deb78c6b511947dfa81";